import React, { useContext, useEffect, useState, useRef, Fragment, useLayoutEffect } from 'react';
import { useTranslation } from 'react-i18next';
import Button from '../../../Common/ui-components/Button';
import PopUpLayer from '../../../Common/ui-components/PopUpLayer';
import RaceSimulatorBottom from './RaceSimulatorBottom';
import { useWindowSize } from '../../../Common/CommonHooks';
import { Input } from '../../../Common/ui-components';
import EnhancedSlider from '../../../Common/ui-components/Slider';
import SegmentedSlider from '../../../Common/ui-components/SegmentedSlider';
import MobilePicker from '../../../Common/ui-components/MobilePicker';
import { getRunnerData, RsHorseName, RsJockey, RsTrainer } from '../../Common/RCOddsTableBase';
import { isLocalMeeting } from '../../../Common/home-common';
import useFetch from '../../../Common/hooks/useFetch';
import { RacingContext } from '../../../Home/RacingPage';
import './Adjust.scss';
import { levelOptions } from './index';
import { scrollTo } from '../../../Common/GlobalFunc';

const EditHr = ({ isEditHr, setIsEditHr, editLine, runnersData, setHorseData, confirmHorseData, reset }) => {
    const { t, i18n } = useTranslation();
    // const [hrValue, setHrValue] = useState(runnersData[editLine].simExtendInfo?.hr);
    const Glossary = window.RaceSimulatorConfig.Glossary[i18n.language];
    const [isFocus, setIsFocus] = useState(false);

    const [landscape, setLandscape] = useState(screen.orientation.type.includes('landscape'));
    useEffect(() => {
        const change = (event) => {
            if (event.target.type.includes('landscape')) {
                setLandscape(true);
                scrollTo(0, 180)
            } else {
                setLandscape(false);
                scrollTo(0, 290)
            }
        };
        screen.orientation.addEventListener('change', change);
        return () => {
            screen.orientation.removeEventListener('change', change);
        };
    }, []);

    return (
        <PopUpLayer
            className="Adjust-PopUpLayer-Edit Adjust-PopUpLayer-Edit-HR"
            onClose={() => {
                reset();
                setIsEditHr(false);
                document
                    .querySelector('.Adjust-PopUpLayer-table-square-checked')
                    ?.classList.remove('Adjust-PopUpLayer-table-square-checked');
            }}
            title={`${t('RS_TD_EDIT')}${Glossary.hr.title}`}
            isOpen={isEditHr}
            setIsOpen={setIsEditHr}
            adjustForKeyboard
            isFocus={isFocus}
        >
            <div style={{ padding: '0 12px' }}>
                <EnhancedSlider
                    trackColor={'#173E9680'}
                    railColor={'#E0E0E0'}
                    handleColor={'#122C68'}
                    handleBorder={'none'}
                    min={1}
                    max={150}
                    handleSize={{ width: 20, height: 20 }}
                    tooltip={false}
                    className="Adjust-PopUpLayer-Edit-HR-slider"
                    value={
                        runnersData[editLine].simExtendInfo?.hr === ''
                            ? 1
                            : parseInt(runnersData[editLine].simExtendInfo?.hr)
                    }
                    onChange={(v) => {
                        setHorseData(editLine, 'hr', v);
                    }}
                />
                <div className="Adjust-PopUpLayer-Edit-number-label">
                    <span>1</span>
                    <span>150</span>
                </div>
                <Input
                    need$={false}
                    min={1}
                    max={150}
                    doInnerBlurWhenOnBlur
                    onBlur={() => {
                        setIsFocus(false);
                    }}
                    onFocus={() => {
                        setIsFocus(true);
                    }}
                    value={
                        runnersData[editLine].simExtendInfo?.hr === ''
                            ? ''
                            : parseInt(runnersData[editLine].simExtendInfo?.hr)
                    }
                    onChange={(v) => {
                        if (v === '' || v <= 150) {
                            setHorseData(editLine, 'hr', v);
                        }
                    }}
                    name="Adjust-PopUpLayer-Edit-input"
                    id="Adjust-PopUpLayer-Edit-input"
                    className="Adjust-PopUpLayer-Edit-input"
                />
            </div>

            <Button
                onClick={() => {
                    confirmHorseData(editLine, 'hr');
                    setIsEditHr(false);
                    document
                        .querySelector('.Adjust-PopUpLayer-table-square-checked')
                        ?.classList.remove('Adjust-PopUpLayer-table-square-checked');
                }}
                style={{ width: '100%' }}
            >
                {t('RS_CONFIRM')}
            </Button>
        </PopUpLayer>
    );
};

const EditLevel = ({
    runnersData,
    reset,
    confirmHorseData,
    setHorseData,
    isEditLevel,
    setIsEditLevel,
    editLine,
    editType
}) => {
    const { t, i18n } = useTranslation();
    // const [fitValue, setFitValue] = useState('A+');
    const value = runnersData[editLine].simExtendInfo?.[editType];

    const Glossary = window.RaceSimulatorConfig.Glossary[i18n.language];

    const [landscape, setLandscape] = useState(screen.orientation.type.includes('landscape'));
    useEffect(() => {
        const change = (event) => {
            if (event.target.type.includes('landscape')) {
                setLandscape(true);
            } else {
                setLandscape(false);
            }
        };
        screen.orientation.addEventListener('change', change);
        return () => {
            screen.orientation.removeEventListener('change', change);
        };
    }, []);
    return (
        <PopUpLayer
            className="Adjust-PopUpLayer-Edit Adjust-PopUpLayer-Edit-FIT"
            onClose={() => {
                reset();
                setIsEditLevel(false);
                document
                    .querySelector('.Adjust-PopUpLayer-table-square-checked')
                    ?.classList.remove('Adjust-PopUpLayer-table-square-checked');
            }}
            title={t('RS_TD_EDIT') + Glossary?.[editType]?.title}
            isOpen={isEditLevel}
            setIsOpen={setIsEditLevel}
        >
            <MobilePicker
                options={levelOptions}
                visibleCountAbove={landscape ? 2 : 3}
                visibleCountBelow={landscape ? 1 : 3}
                itemHeight={38}
                value={value}
                onChange={(v) => {
                    setHorseData(editLine, editType, v.value);
                }}
                labelWidth={14}
                labelAlign="left"
                symmetricStyles={[
                    {
                        distance: 0,
                        color: '#333333',
                        fontSize: '21px',
                        fontWeight: 700
                    },
                    {
                        distance: 1,
                        color: '#8B8B8B',
                        fontSize: '21px',
                        fontWeight: 500
                    },
                    {
                        distance: 2,
                        color: '#E0E0E0',
                        fontSize: '18px',
                        fontWeight: 500
                    },
                    {
                        distance: 3,
                        color: '#E0E0E0',
                        fontSize: '18px',
                        fontWeight: 500
                    },
                    {
                        distance: 4,
                        color: '#E0E0E0',
                        fontSize: '18px',
                        fontWeight: 500
                    },
                    {
                        distance: 5,
                        color: '#F0F0F0',
                        fontSize: '18px',
                        fontWeight: 500
                    }
                ]}
            />
            <Button
                onClick={() => {
                    confirmHorseData(editLine, editType);
                    setIsEditLevel(false);
                    document
                        .querySelector('.Adjust-PopUpLayer-table-square-checked')
                        ?.classList.remove('Adjust-PopUpLayer-table-square-checked');
                }}
                style={{ width: '100%', marginTop: 12 }}
            >
                {t('RS_CONFIRM')}
            </Button>
        </PopUpLayer>
    );
};

const EditTD = ({
    runnersData,
    reset,
    confirmHorseData,
    setHorseData,
    isEditTd,
    setIsEditTd,
    editLine,
    isMobileSize
}) => {
    const { t, i18n } = useTranslation();
    const segments = [
        { start: 1000, end: 1200 },
        { start: 1200, end: 1400 },
        { start: 1400, end: 1600 },
        { start: 1600, end: 1650 },
        { start: 1650, end: 1800 },
        { start: 1800, end: 2000 },
        { start: 2000, end: 2200 },
        { start: 2200, end: 2400 }
    ];

    const trackDistanceArr = [
        { label: t('RS_TD_SPRINT'), start: 1000, end: 1400, color: '#FBBE05' },
        { label: t('RS_TD_MILE'), start: 1400, end: 1800, color: '#BEE429' },
        { label: t('RS_TD_INTERMEDIATE'), start: 1800, end: 2200, color: '#67BED0' },
        { label: t('RS_TD_LONG'), start: 2200, end: 2400, color: '#2655CC' }
    ];

    const Glossary = window.RaceSimulatorConfig.Glossary[i18n.language];

    return (
        <PopUpLayer
            className="Adjust-PopUpLayer-Edit Adjust-PopUpLayer-Edit-TD"
            onClose={() => {
                reset();
                setIsEditTd(false);
                document
                    .querySelector('.Adjust-PopUpLayer-table-square-checked')
                    ?.classList.remove('Adjust-PopUpLayer-table-square-checked');
            }}
            title={t('RS_TD_EDIT') + Glossary.td.title}
            isOpen={isEditTd}
            setIsOpen={setIsEditTd}
        >
            <div style={{ padding: '0 12px' }}>
                <SegmentedSlider
                    colorSegments={trackDistanceArr}
                    valueSegments={segments}
                    value={runnersData[editLine].simExtendInfo?.td}
                    onChange={(val) => {
                        if (Array.isArray(val)) {
                            setHorseData(editLine, 'td', val);
                        }
                    }}
                    handleSize={{ width: 24, height: 24 }}
                    formatTooltip={(val) => `${val}${t('LB_METER')}`}
                    tooltipVisible="always"
                    passedOverlay={true}
                    passedColor="#E0E0E0"
                />
                <div className="Adjust-PopUpLayer-Edit-number-label">
                    <span>1000{t('LB_METER')}</span>
                    <span>2400{t('LB_METER')}</span>
                </div>
                <span className="Adjust-PopUpLayer-Edit-TD-title">{t('RS_TD_DISTANCE_CATEGORY')}:</span>
                <div className="Adjust-PopUpLayer-Edit-TD-explain-con">
                    <div className="Adjust-PopUpLayer-Edit-TD-explain-line">
                        {trackDistanceArr.slice(0, 4).map((item, index) => {
                            return (
                                <div key={index} className={`Adjust-PopUpLayer-Edit-TD-explain-item-label`}>
                                    <span
                                        style={{ backgroundColor: item.color }}
                                        className="Adjust-PopUpLayer-Edit-TD-explain-item-color"
                                    ></span>
                                    <span>{item.label}</span>
                                </div>
                            );
                        })}
                    </div>
                </div>
            </div>
            <Button
                onClick={() => {
                    confirmHorseData(editLine, 'td');
                    setIsEditTd(false);
                    document
                        .querySelector('.Adjust-PopUpLayer-table-square-checked')
                        ?.classList.remove('Adjust-PopUpLayer-table-square-checked');
                }}
                style={{ width: '100%' }}
            >
                {t('RS_CONFIRM')}
            </Button>
        </PopUpLayer>
    );
};

const EditRs = ({ runnersData, reset, confirmHorseData, setHorseData, isEditRs, setIsEditRs, editLine }) => {
    const { t, i18n } = useTranslation();
    const Glossary = window.RaceSimulatorConfig.Glossary[i18n.language];
    const rsArray = [
        { label: t('RS_RS_LEAD') },
        { label: t('RS_TD_ON_PACE') },
        { label: t('RS_TD_MIDFIELD') },
        { label: t('RS_TD_REAR') }
    ];
    // const [rsChecked, setRsChecked] = useState(1);
    const value = parseInt(runnersData[editLine].simExtendInfo?.rs);
    return (
        <PopUpLayer
            className="Adjust-PopUpLayer-Edit Adjust-PopUpLayer-Edit-RS"
            onClose={() => {
                reset();
                setIsEditRs(false);
                document
                    .querySelector('.Adjust-PopUpLayer-table-square-checked')
                    ?.classList.remove('Adjust-PopUpLayer-table-square-checked');
            }}
            title={t('RS_TD_EDIT') + Glossary.rs.title}
            isOpen={isEditRs}
            setIsOpen={setIsEditRs}
        >
            <div className="Adjust-PopUpLayer-Edit-RS-item-con">
                {rsArray.map((item, index) => {
                    return (
                        <div
                            key={index}
                            onClick={() => {
                                setHorseData(editLine, 'rs', index + 1);
                            }}
                            className={`Adjust-PopUpLayer-Edit-RS-item ${index + 1 === value ? 'checked' : ''}`}
                        >
                            <div className="Adjust-PopUpLayer-Edit-RS-item-img-con">
                                {[0, 1, 2, 3].map((i, index1) => {
                                    return (
                                        <span
                                            key={index1}
                                            className={`Adjust-PopUpLayer-Edit-RS-item-img-${
                                                i === index ? 'TriangleBlue' : 'TriangleGrey'
                                            }`}
                                        ></span>
                                    );
                                })}
                            </div>
                            <span>{item.label}</span>
                        </div>
                    );
                })}
            </div>
            <Button
                onClick={() => {
                    confirmHorseData(editLine, 'rs');
                    setIsEditRs(false);
                    document
                        .querySelector('.Adjust-PopUpLayer-table-square-checked')
                        ?.classList.remove('Adjust-PopUpLayer-table-square-checked');
                }}
                style={{ width: '100%' }}
            >
                {t('RS_CONFIRM')}
            </Button>
        </PopUpLayer>
    );
};

const Adjust = ({
    content,
    isOpenAdjust,
    setIsOpenAdjust,
    runnersData,
    resetRunners,
    setHorseData,
    confirmHorseData,
    reset,
    onViewResult
}) => {
    const { t, i18n } = useTranslation();
    const { isMobileSize } = useWindowSize();

    const context = useContext(RacingContext);
    const { venue, raceNo } = content;
    let isLocal = isLocalMeeting(venue);

    const title = (
        <div className="Adjust-PopUpLayer-title">
            <span>{t('RS_RACE_N').replace('{n}', raceNo)}</span>
            <span>{t('RS_EDIT_HORSE_ATTRIBUTE')}</span>
        </div>
    );

    const [isEditHr, setIsEditHr] = useState(false);
    const [isEditLevel, setIsEditLevel] = useState(false);
    const [isEditTd, setIsEditTd] = useState(false);
    const [isEditRs, setIsEditRs] = useState(false);

    const [editLine, setEditLine] = useState(0);
    const [editType, setEditType] = useState();

    const [shadow, setShadow] = useState(false);
    const [hasScroll, setHasScroll] = useState(false);
    const [canScrollWidth, setCanScrollWidth] = useState(0);
    useLayoutEffect(() => {
        setShadow(false);
        setHasScroll(false);
    }, [raceNo]);

    const Glossary = window.RaceSimulatorConfig.Glossary[i18n.language];

    const onClose = () => {
        setIsOpenAdjust(false);
        setShadow(false);
        setHasScroll(false);
    };
    if (!(runnersData?.length > 0)) {
        return null;
    }
    return (
        <>
            <div className={`Adjust-Horse-Attribute`}>
                <Button
                    onClick={() => {
                        setIsOpenAdjust(true);
                    }}
                    themeColor="#122C68"
                    width={'100%'}
                    variant="outlined"
                >
                    <span className="Edit-icon"></span>
                    {t('RS_ADJUST_HORSE_ATTRIBUTE')}
                </Button>
            </div>
            <PopUpLayer
                className="Adjust-PopUpLayer"
                size="large"
                onClose={onClose}
                title={title}
                isOpen={isOpenAdjust}
                setIsOpen={setIsOpenAdjust}
                footer={<RaceSimulatorBottom resetRunners={resetRunners} onViewResult={onViewResult} fixed boxShadow isOpenAdjust={isOpenAdjust} />}
                setShadow={setShadow}
                setHasScroll={setHasScroll}
                setCanScrollWidth={setCanScrollWidth}
                bottomSheetAttribute={{
                    bodyOverflowHidden: false,
                    useSafeAreaPaddingBottom: true,
                }}
                key={raceNo}
            >
                <table className="Adjust-PopUpLayer-table">
                    <thead>
                        <tr>
                            <th
                                className={`Adjust-PopUpLayer-table-no ${
                                    hasScroll ? 'Adjust-PopUpLayer-table-no-fixed' : ''
                                } ${shadow ? 'Adjust-PopUpLayer-table-no-shadow' : ''}`}
                            >
                                <div style={{ whiteSpace: 'nowrap', display: 'flex', justifyContent: 'flex-end' }}>
                                    {t('RS_NO')}
                                </div>
                            </th>
                            <th
                                className={`Adjust-PopUpLayer-table-horse ${
                                    hasScroll ? 'Adjust-PopUpLayer-table-horse-fixed' : ''
                                } ${shadow ? 'Adjust-PopUpLayer-table-horse-shadow' : ''}`}
                            >
                                {t('RS_HORSE')}
                            </th>
                            {window.RaceSimulatorConfig.EditTableOrder.map((i) => {
                                return (
                                    <th
                                        key={i}
                                        className={`Adjust-PopUpLayer-table-${i} ${
                                            i === 'dw' && shadow ? 'Adjust-PopUpLayer-table-dw-shadow' : ''
                                        }`}
                                    >
                                        {Glossary[i].title}
                                    </th>
                                );
                            })}
                        </tr>
                    </thead>
                    <tbody>
                        {runnersData.map((runner, index) => {
                            const simExtendInfo = runner.simExtendInfo;
                            return (
                                <tr key={index}>
                                    <td
                                        className={`Adjust-PopUpLayer-table-no ${
                                            hasScroll ? 'Adjust-PopUpLayer-table-no-fixed' : ''
                                        } ${shadow ? 'Adjust-PopUpLayer-table-no-shadow' : ''}`}
                                    >
                                        <div>
                                            <span>{runner?.no}</span>
                                            {isMobileSize && (
                                                <div className="Adjust-PopUpLayer-table-horse-colour">
                                                    {runner.colorTxt}
                                                </div>
                                            )}
                                        </div>
                                    </td>
                                    <td
                                        className={`Adjust-PopUpLayer-table-horse ${
                                            hasScroll ? 'Adjust-PopUpLayer-table-horse-fixed' : ''
                                        }  ${shadow ? 'Adjust-PopUpLayer-table-horse-shadow' : ''}`}
                                    >
                                        <div className="Adjust-PopUpLayer-table-horse-container">
                                            {!isMobileSize && (
                                                <div className="Adjust-PopUpLayer-table-horse-colour">
                                                    {runner.colorTxt}
                                                </div>
                                            )}
                                            <div className="Adjust-PopUpLayer-table-horse-content">
                                                <div className="Adjust-PopUpLayer-table-horse-name">
                                                    <RsHorseName
                                                        t={t}
                                                        isLocal={isLocal}
                                                        raceNo={raceNo}
                                                        id={runner.id}
                                                        runnerNo={runner.no}
                                                        name={`${runner.name}${
                                                            runner.isScratch ? ` (${t('LB_RC_SCR')})` : ''
                                                        }`}
                                                        racingColorFileName={runner.racingColorFileName}
                                                    />
                                                </div>
                                                <div className="Adjust-PopUpLayer-table-horse-JT">
                                                    <div className="Adjust-PopUpLayer-table-horse-J">
                                                        <span className="Adjust-PopUpLayer-table-horse-J-icon">
                                                            {t('LB_RACE_JKC_SHORT')}
                                                        </span>
                                                        <span className="Adjust-PopUpLayer-table-horse-J-name">
                                                            {runner.isScratch ? (
                                                                '--'
                                                            ) : (
                                                                <RsJockey
                                                                    t={t}
                                                                    isLocal={isLocal}
                                                                    raceNo={raceNo}
                                                                    runnerNo={runner.no}
                                                                    jockyId={runner.jockyId}
                                                                    jocky={runner.jocky}
                                                                    alw={runner.alw}
                                                                />
                                                            )}
                                                        </span>
                                                    </div>
                                                    {((isMobileSize && window.innerWidth >= 800) ||
                                                        (!shadow && isMobileSize && window.innerWidth < 800) ||
                                                        !isMobileSize) && (
                                                        <div className="Adjust-PopUpLayer-table-horse-T">
                                                            <span className="Adjust-PopUpLayer-table-horse-T-icon">
                                                                {t('LB_RACE_TRN_SHORT')}
                                                            </span>
                                                            <span className="Adjust-PopUpLayer-table-horse-T-name">
                                                                {runner.isScratch ? (
                                                                    '--'
                                                                ) : (
                                                                    <RsTrainer
                                                                        t={t}
                                                                        isLocal={isLocal}
                                                                        raceNo={raceNo}
                                                                        runnerNo={runner.no}
                                                                        trnId={runner.trnId}
                                                                        trn={runner.trn}
                                                                    />
                                                                )}
                                                            </span>
                                                        </div>
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                    </td>
                                    {window.RaceSimulatorConfig.EditTableOrder.map((i) => {
                                        return (
                                            <>
                                                {i === 'dw' && (
                                                    <td
                                                        className={`Adjust-PopUpLayer-table-dw  ${
                                                            shadow ? 'Adjust-PopUpLayer-table-dw-shadow' : ''
                                                        }`}
                                                    >
                                                        {runner.isScratch ? '--' : runner.draw}
                                                    </td>
                                                )}
                                                {i === 'hr' && (
                                                    <td className="Adjust-PopUpLayer-table-hr">
                                                        {runner.isScratch ? (
                                                            '--'
                                                        ) : (
                                                            <div
                                                                className="Adjust-PopUpLayer-table-square"
                                                                onClick={(e) => {
                                                                    e.target.classList.add(
                                                                        'Adjust-PopUpLayer-table-square-checked'
                                                                    );
                                                                    setEditLine(index);
                                                                    setIsEditHr(true);
                                                                }}
                                                            >
                                                                {simExtendInfo?.hr === '' ? (
                                                                    <span>&nbsp;</span>
                                                                ) : (
                                                                    isNaN(parseInt(simExtendInfo?.hr)) ? '' : parseInt(simExtendInfo?.hr)
                                                                )}
                                                            </div>
                                                        )}
                                                    </td>
                                                )}
                                                {i === 'fit' && (
                                                    <td className="Adjust-PopUpLayer-table-fit">
                                                        {runner.isScratch ? (
                                                            '--'
                                                        ) : (
                                                            <div
                                                                className="Adjust-PopUpLayer-table-square"
                                                                onClick={(e) => {
                                                                    e.target.classList.add(
                                                                        'Adjust-PopUpLayer-table-square-checked'
                                                                    );
                                                                    setEditType('fit');
                                                                    setEditLine(index);
                                                                    setIsEditLevel(true);
                                                                }}
                                                            >
                                                                {simExtendInfo?.['fit']}
                                                            </div>
                                                        )}
                                                    </td>
                                                )}
                                                {i === 'jk' && (
                                                    <td className="Adjust-PopUpLayer-table-jk">
                                                        {runner.isScratch ? (
                                                            '--'
                                                        ) : (
                                                            <div
                                                                className="Adjust-PopUpLayer-table-square"
                                                                onClick={(e) => {
                                                                    e.target.classList.add(
                                                                        'Adjust-PopUpLayer-table-square-checked'
                                                                    );
                                                                    setEditType('jk');
                                                                    setEditLine(index);
                                                                    setIsEditLevel(true);
                                                                }}
                                                            >
                                                                {simExtendInfo?.['jk']}
                                                            </div>
                                                        )}
                                                    </td>
                                                )}
                                                {i === 'tn' && (
                                                    <td className="Adjust-PopUpLayer-table-tn">
                                                        {runner.isScratch ? (
                                                            '--'
                                                        ) : (
                                                            <div
                                                                className="Adjust-PopUpLayer-table-square"
                                                                onClick={(e) => {
                                                                    e.target.classList.add(
                                                                        'Adjust-PopUpLayer-table-square-checked'
                                                                    );
                                                                    setEditType('tn');
                                                                    setEditLine(index);
                                                                    setIsEditLevel(true);
                                                                }}
                                                            >
                                                                {simExtendInfo?.['tn']}
                                                            </div>
                                                        )}
                                                    </td>
                                                )}

                                                {i === 'td' && (
                                                    <td className="Adjust-PopUpLayer-table-td">
                                                        {runner.isScratch ? (
                                                            '--'
                                                        ) : (
                                                            <div
                                                                className="Adjust-PopUpLayer-table-square Adjust-PopUpLayer-table-square-td"
                                                                onClick={(e) => {
                                                                    e.target.classList.add(
                                                                        'Adjust-PopUpLayer-table-square-checked'
                                                                    );
                                                                    setEditLine(index);
                                                                    setIsEditTd(true);
                                                                }}
                                                            >
                                                                {simExtendInfo?.td[0]}-{simExtendInfo?.td[1]}
                                                            </div>
                                                        )}
                                                    </td>
                                                )}
                                                {i === 'rs' && (
                                                    <td className="Adjust-PopUpLayer-table-rs">
                                                        {runner.isScratch ? (
                                                            '--'
                                                        ) : (
                                                            <div
                                                                className="Adjust-PopUpLayer-table-square Adjust-PopUpLayer-table-square-rs"
                                                                onClick={(e) => {
                                                                    e.currentTarget.classList.add(
                                                                        'Adjust-PopUpLayer-table-square-checked'
                                                                    );
                                                                    setEditLine(index);
                                                                    setIsEditRs(true);
                                                                }}
                                                            >
                                                                <div
                                                                    className={`RunningStyle RunningStyle${parseInt(
                                                                        simExtendInfo?.rs
                                                                    )}`}
                                                                ></div>
                                                            </div>
                                                        )}
                                                    </td>
                                                )}
                                                {i === 'l6' && (
                                                    <td className={`Adjust-PopUpLayer-table-l6`}>
                                                        <div className="Adjust-PopUpLayer-table-l6-con">
                                                            {runner.isScratch
                                                                ? '--'
                                                                : runner?.last6?.split('/')?.map((i, index) => {
                                                                      return (
                                                                          <Fragment key={index}>
                                                                              {index !== 0 && (
                                                                                  <span
                                                                                      className={`Adjust-PopUpLayer-table-l6-arrow`}
                                                                                  ></span>
                                                                              )}
                                                                              <span
                                                                                  className={`Adjust-PopUpLayer-table-l6-item Adjust-PopUpLayer-table-l6-${i}`}
                                                                              >
                                                                                  {i}
                                                                              </span>
                                                                          </Fragment>
                                                                      );
                                                                  })}
                                                        </div>
                                                    </td>
                                                )}
                                            </>
                                        );
                                    })}
                                </tr>
                            );
                        })}
                    </tbody>
                </table>
                {shadow && <div className="Adjust-PopUpLayer-table-box-shadow"></div>}
            </PopUpLayer>
            <EditHr
                key={'Hr' + editLine}
                {...{ runnersData, reset, confirmHorseData, setHorseData, isEditHr, setIsEditHr, editLine }}
            />
            <EditLevel
                key={editType + editLine}
                {...{
                    runnersData,
                    reset,
                    confirmHorseData,
                    setHorseData,
                    isEditLevel,
                    setIsEditLevel,
                    editLine,
                    editType
                }}
            />
            <EditTD
                key={'TD' + editLine}
                {...{
                    isMobileSize,
                    runnersData,
                    reset,
                    confirmHorseData,
                    setHorseData,
                    isEditTd,
                    setIsEditTd,
                    editLine
                }}
            />
            <EditRs
                key={'Rs' + editLine}
                {...{ runnersData, reset, confirmHorseData, setHorseData, isEditRs, setIsEditRs, editLine }}
            />
        </>
    );
};
export default Adjust;
